import { AxiosPromise } from 'axios'
import { createPacksClient } from './createPacksClient'
import {
  addAssetToPack,
  postSyncPack,
  updateJoinPack,
  refreshPack,
  joinPack,
  copyPack,
  updateAsset,
  createAsset,
  updatePack,
  deleteStickerAsset,
  deleteRawAsset,
  createPack,
  getPacks,
  deletePack,
  removeInvitedPack,
  getPackAssets,
  getPack,
  deleteAsset,
  getPackShareTokens,
  updateShareToken,
  getIcon,
  searchPacks,
  getTeam,
  moveToSuperpack,
  templatize,
  importPack,
  exportPack,
  upload,
  startChunk,
  chunk,
  endChunk
} from './methods'
import { PacksClient as BasePacksClient } from './types'
import { PacksClientOptions, JoinPackResponse, GetPackResponseData, CreatePackPayload } from './types/PacksClient'

export default function PacksClient(options?: PacksClientOptions): PacksClient {
  const commonOptions = {}

  return createPacksClient({
    ...commonOptions,
    ...options,
    methods: {
      createPack,
      templatize,
      joinPack,
      getPacks,
      getPack,
      getPackAssets,
      copyPack,
      removeInvitedPack,
      deletePack,
      updatePack,
      addAssetToPack,
      deleteStickerAsset,
      deleteRawAsset,
      updateAsset,
      createAsset,
      refreshPack,
      postSyncPack,
      deleteAsset,
      getPackShareTokens,
      updateShareToken,
      searchPacks,
      getTeam,
      moveToSuperpack,
      updateJoinPack,
      getIcon,
      importPack,
      exportPack,
      upload,
      startChunk,
      chunk,
      endChunk
    },
  })
}

export type PacksClient = BasePacksClient & {
  readonly getIcon: (id: string, hash: string) => AxiosPromise<any>,
  readonly joinPack: (id: string, key?: string, key_id?: string) => AxiosPromise<JoinPackResponse>,
  readonly createPack: ({ title, superpack_id, key_id, key, share_keys }: CreatePackPayload) => AxiosPromise<any>,
  readonly getPacks: () => AxiosPromise<GetPackResponseData[]>,
  readonly removeInvitedPack: (id: string) => AxiosPromise<any>,
  readonly deletePack: (id: string) => AxiosPromise<any>
  readonly copyPack: (id: string) => AxiosPromise<any>
  readonly getPack: (id: string) => AxiosPromise<any>
  readonly updatePack: (packId: string, meta: any) => AxiosPromise<any>
  readonly updateJoinPack: (packId: string, data: any) => AxiosPromise<any>
  readonly addAssetToPack: (id: string, meta: any) => AxiosPromise<any>
  readonly getPackAssets: (id: string) => AxiosPromise<any>
  readonly deleteStickerAsset: (packId: string) => AxiosPromise<any>
  readonly deleteRawAsset: (packId: string) => AxiosPromise<any>
  readonly updateAsset: (packId: string, assetId: string, data: any) => AxiosPromise<any>
  readonly createAsset: (packId: string, data: any) => AxiosPromise<any>
  readonly refreshPack: (packId: string, hash: string, time: string) => AxiosPromise<any>
  readonly postSyncPack: (packId: string, data: any) => AxiosPromise<any>
  readonly deleteAsset: (packId: string, assetId: string) => AxiosPromise<any>
  readonly getPackShareTokens: (id: string) => AxiosPromise<any>
  readonly updateShareToken: (packId: string, shareTokenId: string, shareToken: any) => AxiosPromise<any>,
  readonly searchPacks: (search: string) => AxiosPromise<any>
  readonly getTeam: (packId: string) => AxiosPromise<any>
  readonly moveToSuperpack: (packId: string, superpackId: string) => AxiosPromise<any>
  readonly templatize: (id: string) => AxiosPromise;
  readonly importPack: (upload_token: string, to_template?: boolean, from_template?: boolean) => AxiosPromise;
  readonly exportPack: (id: string) => AxiosPromise;
  readonly upload: (id: string, attachment: any, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
  readonly startChunk: (id: string, attachment: any, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
  readonly chunk: (id: string, handle: string, attachment: any, number: number, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
  readonly endChunk: (id: string, handle: string, attachment: any, number: number, onUploadProgress?: (progressEvent: any) => void) => AxiosPromise;
}
